import { FC } from 'react';
import {
    ResponseModalContent,
    Props as ResponseModalContentProps
} from 'shared/components/ResponseModalContent';
import emailAlertsSvg from '../../public/assets/search/multiple-properties-email.svg';
import saveSearchSvg from '../../public/assets/search/multiple-properties-location.svg';
import errorSvg from '../../public/assets/search/alert-triangle-purple.svg';

export type ResponseType =
    | 'saveSearchSuccess'
    | 'saveAlertSuccess'
    | 'saveSearchFailure'
    | 'saveAlertFailure'
    | null;

export type Props = {
    responseType: ResponseType;
    close: () => void;
    action?: () => void;
};

const successText = {
    title: 'Success!',
    buttonText: 'Return to search results',
    note: 'We will not share your details with third parties'
};

const saveSearchSuccessText = {
    heading: 'Success! Your search has been saved',
    text: 'You can access your saved searches from your MyZoopla account',
    linkText: 'Manage my saved searches'
};

const saveAlertSuccessText = {
    heading: 'Success! Your email alert has been created',
    text: 'We’ll send you alerts when new properties come in and match your search criteria',
    linkText: 'Manage my email alerts'
};

const failureText = {
    buttonText: 'Retry',
    linkText: 'Go back to search results',
    note: 'We will not share your details with third parties'
};

const saveSearchFailureText = {
    title: 'Failed to save search',
    heading: 'We weren’t able to save your search',
    text: 'An error occurred when we were creating your saved search. Please try saving the search again.'
};

const saveAlertFailureText = {
    title: 'Failed to create alert',
    heading: 'We weren’t able to create your email alert',
    text: 'An error occurred when we were creating your email alert. Please try creating the alert again.'
};

const getContentModel = (
    responseType: ResponseType,
    close: () => void,
    buttonAction?: () => void
) => {
    switch (responseType) {
        case 'saveSearchSuccess':
            return {
                ...successText,
                ...saveSearchSuccessText,
                image: saveSearchSvg,
                buttonAction: close,
                linkUrl: '/myaccount/alerts-searches/',
                linkAction: undefined,
                linkType: 'url'
            };
        case 'saveSearchFailure':
            return {
                ...failureText,
                ...saveSearchFailureText,
                image: errorSvg,
                buttonAction,
                linkUrl: undefined,
                linkAction: close,
                linkType: 'action'
            };
        case 'saveAlertSuccess':
            return {
                ...successText,
                ...saveAlertSuccessText,
                image: emailAlertsSvg,
                buttonAction: close,
                linkUrl: '/myaccount/alerts-searches/',
                linkAction: undefined,
                linkType: 'url'
            };
        case 'saveAlertFailure':
        default:
            return {
                ...failureText,
                ...saveAlertFailureText,
                image: errorSvg,
                buttonAction,
                linkUrl: undefined,
                linkAction: close,
                linkType: 'action'
            };
    }
};

export const XhrResponseModalContent: FC<Props> = ({
    responseType,
    close,
    action
}) => {
    const contentModel = getContentModel(responseType, close, action);

    return (
        <ResponseModalContent
            {...(contentModel as ResponseModalContentProps)}
        />
    );
};
